import { RightRail, RightRailClose } from 'blaze-ui/icons'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

export const TabsToggleButton = observer(() => {
  const { designStore, rightRailPanelStore } = useRootStore()

  if (!designStore) return null

  const toggle = () => {
    if (designStore.isTabOpen) {
      designStore.closeTab()
      rightRailPanelStore.hide()
    } else {
      designStore.openDefaultTab()
    }
  }

  return <Button icon={designStore.isTabOpen ? RightRailClose : RightRail} onPress={toggle} />
})
